import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Navbar from "./components/nav/Navbar";
import "./main.css";
import AddNewTask from "./pages/AddNewTask";
import EditTask from "./pages/EditTask";
import Home from "./pages/Home";

function App() {
	return (
		<BrowserRouter>
			<Navbar />
			<div className="container relative">
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="/new-task" element={<AddNewTask />} />
					<Route path="/edit-task/:taskId" element={<EditTask />} />
				</Routes>
			</div>
		</BrowserRouter>
	);
}

export default App;
